<template lang="pug">
  .report
    .button
      PButton(
        color="success"
        size="md"
        @click="generate()"
        :loading="loading"
        :disabled="!valid"
      ) gerar relatório

</template>

<script>
import moment from 'moment'

export default {
  props: {
    reportInfo: {type: Object},
    valid: {type: Boolean}
  },
  data () {
    return {
      loading: false,
      reportOptions: {}
    }
  },
  methods: {
    async generate () {
      this.loading = true

      let result

      const params = {
        start_date: moment(this.reportInfo.periodData.startDate).format('DD/MM/YYYY'),
        end_date: moment(this.reportInfo.periodData.endDate).format('DD/MM/YYYY'),
        ...this.reportOptions
      }

      const entidadesValidas = [
        'companies',
        'employees',
        'users'
      ]

      const entidadeSelecionada = this.reportInfo.entity

      const entidadeSelecionadaValida = entidadesValidas.find(v => v === entidadeSelecionada)

      if (entidadeSelecionadaValida) {
        params[entidadeSelecionadaValida] = this.reportInfo.entityContent.map(i => i.id)
      }

      try {
        result = await this.$API.R35.save(params)
      } catch (e) {
        result = e
      }
      this.$emit('handleReport', result)

      this.loading = false
    }
  }
}
</script>

<style scoped lang="scss">
.report {
  display: grid;
  grid-row-gap: 10px;
  .button {
    justify-self: end;

    display: grid;
    grid-auto-flow: column;
    grid-column-gap: 10px;
  }
}
</style>
